export const STATUS_MAP = {
  clarifying: { label: "Clarifying", color: "info" },
  investigating: { label: "Investigating", color: "info" },
  "awaiting-approval": { label: "Plan ready", color: "info" },
  queued: { label: "Queued", color: "info" },
  fixing: { label: "Fixing", color: "warning" },
  verifying: { label: "Verifying", color: "warning" },
  "ready-to-retest": { label: "Ready to retest", color: "success" },
  "fix-failed": { label: "Fix failed", color: "error" },
  escalated: { label: "Escalated", color: "error" },
  closed: { label: "Closed", color: "default" }
};

export const getStatusDisplay = (status) =>
  STATUS_MAP[status] || { label: status || "Unknown", color: "default" };
